import logo from '../../logo.png';
import logo2 from '../../mbe-collection.gif';
import "./Main.css";
import React, { useState } from 'react';
import Nftpuller from '../../n2dpuller/nftpuller';
import { Container, Text, Spacer, } from '@nextui-org/react';
import { useAccount } from 'wagmi';

export default function Main() {

  // Init some empty variables
  const [state, setState] = useState({
    myWallet: "",
    selCont: ""
  });

  const msbCont = "0x9e02C26CDBB3040e8CAb59604DEa8B6118EB643e";
  const mbeCont = "0x87a8A1c2193102fCFF25Ed0A7dfe0Cc13005b3EA";
 
  const msbContUrl = "https://memescan.io/address/0x9e02C26CDBB3040e8CAb59604DEa8B6118EB643e";
  const mbeContUrl = "https://memescan.io/address/0x87a8A1c2193102fCFF25Ed0A7dfe0Cc13005b3EA";
    
  const MyComponent = () => {
    const { isConnecting, isDisconnected } = useAccount()
      if (isConnecting) return <div>Wallet Connecting…</div>
      if (isDisconnected) return <div>Wallet Disconnected</div>
      //return <div>{address}</div>
  }

  const { isDisconnected, isConnected } = useAccount();

  // All in one form field onChange/onClick handler
  const handleChange = evt => {
    evt.preventDefault(); // prevent page refresh

    const name = evt.target.name;
    const value =
    evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
    setState({
      ...state,
      [name]: value
    })
    console.log(evt.target.name);
    console.log(evt.target.value);
  }
//  <img src={logo} className="App-logo" alt="logo" />

  return (
    <div className="main"><br />
      <img src={logo2} className="circular--square" alt="logo" />
      <Container md>
        <Text b css={{color:'$white'}} size={'40px'}>NFT Collection Viewer</Text>
        <Text css={{color:'$white'}} size={'14px'}>NOTE: NFT's locked in staking contract will not be displayed<br /></Text>
      </Container>
      <Container
        display="flex"
        alignItems="center"
        justify="center"
        css={{ width: '400px' }}
      >
        {
          // if wallet isDisconnected show the please connect wallet message
          isDisconnected && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} ><br />
              <Text b css={{color:'$white'}} size={'18px'}><br />Please Connect Wallet</Text>
            </div>
          )
        }
        {
          // Only show collection selection if wallet is connected
          isConnected && (
            <form>
            <Spacer y=".5"/>
            <select name="selCont" onChange={ handleChange } value={ state.selCont }>
              <option value="" disabled hidden>Select An NFT Collection To View</option>
              <option value="msb">MemeShib NFT's First Edition</option>
              <option value="mbe">MemeShib NFT's Blue Edition</option>
            </select>
          </form>
            )
        }
        {
          // show explorer link for selected contract
          state.selCont === "msb" && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
              <Text css={{color:'$white'}} size={'12px'}>Contract Address:&nbsp;
                <a className="App-link" href={msbContUrl} target="_blank" rel="noopener noreferrer" >
                {msbCont} </a><br /><br />
              </Text>
            </div>
          )
        }
        {
          // show explorer link for selected contract
          state.selCont === "mbe" && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
              <Text css={{color:'$white'}} size={'12px'}>Contract Address:&nbsp;
                <a className="App-link" href={mbeContUrl} target="_blank" rel="noopener noreferrer" >
                {mbeCont} </a><br /><br />
              </Text>
            </div>
          )
        }
      </Container>
      { state.selCont && ( <Nftpuller selCont = {state.selCont} /> )}
    </div>
  );
}
//         <MyComponent />
